<div>
  <div class="tw-flex tw-justify-end tw-mr-2">
    <button mat-icon-button (click)="dialogRef.close()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
  <h4 id="title" class="tw-text-center tw-mb-16">Select Destination</h4>
  <div class="tw-px-[24px]">
    <search-filter
      [filterConfig]="filterConfig"
      [search]="search"
      [doSearch]="doSearch"
      class="tw-mb-[16px]"
    />
    <mat-divider class="light tw-mt-[16px]"></mat-divider>
    <folder-path
      [folderTree]="selectFolderDialogService.folderTree()"
      [folderId]="selectFolderDialogService.currentParentFolderId"
      (folderClicked)="enterFolder({ id: $event })"
      [rootName]="data.kind + 's'"
    />
    <mat-divider class="light tw-mb-[16px]"></mat-divider>
    <table class="tw-w-full">
      <thead>
        <tr class="list-header">
          <th>Name</th>
        </tr>
      </thead>
    </table>
  </div>
  <mat-dialog-content
    class="tw-max-h-[50vh] tw-min-h-[30vh] tw-overflow-y-auto"
  >
    <table
      class="tw-table-fixed tw-w-full"
      rvSpinner="folders-list-loader"
      [rvShowSpinner]="selectFolderDialogService.loading()"
    >
      <tbody>
        @for (folder of selectFolderDialogService.folders(); track folder.id) {
          <tr
            (click)="enterFolder(folder)"
            [class.disabled]="shouldDisable(folder.id)"
          >
            <td class="tw-w-full tw-max-w-0 tw-overflow-hidden">
              <div class="tw-flex tw-items-center tw-gap-4 tw-overflow-hidden">
                <mat-checkbox
                  [checked]="folder.isSelected"
                  (click)="$event.stopPropagation()"
                  (change)="selectFolder(folder)"
                  [disabled]="shouldDisable(folder.id)"
                />
                <mat-icon class="tw-text-gray-500" svgIcon="folder" />
                <span
                  class="tw-font-semibold tw-text-ellipsis tw-overflow-hidden tw-whitespace-nowrap tw-block"
                >
                  {{ folder.name }}
                </span>
              </div>
            </td>
          </tr>
        } @empty {
          @if (selectFolderDialogService.loading()) {
            <tr>
              <td class="tw-text-center tw-text-gray-500">
                Loading folders...
              </td>
            </tr>
          } @else if (search.query) {
            <tr>
              <td class="tw-text-center tw-text-gray-500">
                <span>No folders found</span>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </mat-dialog-content>
  <mat-divider class="light"></mat-divider>
  <mat-dialog-actions align="end" class="tw-p-[24px] tw-gap-[8px]">
    <button matButton="outlined" (click)="dialogRef.close()">Cancel</button>
    <new-folder-button
      [existingFiles]="selectFolderDialogService.folders()"
      [parentId]="selectFolderDialogService.currentParentFolderId"
      [kind]="data.kind"
      (folderAdded)="handleFolderCreated()"
    />
    <button
      mat-flat-button
      color="primary"
      (click)="moveFolder()"
      [disabled]="selectFolderDialogService.loading()"
    >
      Move{{ someFolderIsSelected ? '' : ' Here' }}
    </button>
  </mat-dialog-actions>
</div>
